
export const SPRITE_PATHS = {
  "default": "/_nuxt/nuxt-svg/sprite-default.rhCsW31VM4.svg"
}
export const runtimeOptions = {"ariaHidden":false}
